import jQuery from 'jquery';

export default function beachesPagePart() {

    jQuery(() => {
        const mainSelector = jQuery('.beach');
        mainSelector.on('click',function (e) {
            let target = jQuery(this).data( "src-target" );
            if(target){
                document.location.href = target;
            }
        });
    });
}
